<div class="hunt-template-container" id="hunt-template-list-page">
  <hyperkit-button
    size="small"
    class="new-template-button"
    (click)="addToNewTemplate()"
    variant="standard"
    color="tertiary"
    text="New Hunt Template"
  ></hyperkit-button>
  <div class="content">
    <kendo-grid
      [data]="huntTemplateStateService.results | async"
      kendoGridSelectBy="id"
      [pageSize]="(huntTemplateStateService.huntTemplateState | async).take"
      [skip]="(huntTemplateStateService.huntTemplateState | async).skip"
      (dataStateChange)="onHuntTemplatePageChange($event)"
      [pageable]="true"
      [sortable]="true"
      [sort]="(huntTemplateStateService.huntTemplateState | async).sort"
      [groupable]="false"
      [selectable]="true"
      [filterable]="true"
      [filter]="(huntTemplateStateService.huntTemplateState | async).filter"
      [reorderable]="true"
      [resizable]="true"
    >
      <ng-template kendoGridToolbarTemplate>
        <hyperkit-button
          size="small"
          (click)="clearAllFilters()"
          variant="standard"
          color="secondary"
          icon="filter"
          text="Clear All Filters"
        ></hyperkit-button>
        @if (!(huntTemplateStateService.huntTemplateState | async).archived) {
          <hyperkit-button
            size="small"
            (click)="toggleArchivedTemplates()"
            variant="link"
            color="primary"
            icon="filter"
            text="View Archived"
          ></hyperkit-button>
        }
        @if ((huntTemplateStateService.huntTemplateState | async).archived) {
          <hyperkit-button
            size="small"
            (click)="toggleArchivedTemplates()"
            variant="standard"
            color="secondary"
            iconPosition="right"
            icon="x"
            text="Archived"
          ></hyperkit-button>
        }

        <!-- <kendo-chip
        *ngIf="(huntTemplateStateService.huntTemplateState | async).archived"
        label="Archived"
        themeColor="info"
        [removable]="true"
        (remove)="toggleArchivedTemplates()"
        >
      </kendo-chip> -->
      </ng-template>
      <kendo-grid-column field="name" title="Template Name" [width]="300">
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
          <kendo-grid-string-filter-cell
            [showOperators]="false"
            [column]="column"
            [filter]="
              (huntTemplateStateService.huntTemplateState | async).filter
            "
          >
          </kendo-grid-string-filter-cell>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          @if (dataItem.archived) {
            <hyperkit-typography variant="emphasized" size="sm" color="body">
              {{ dataItem.name }}
            </hyperkit-typography>
          } @else {
            <hyperkit-link
              routerLink="/hunt/hunt-template/{{ dataItem.id }}"
              variant="emphasized"
              size="sm"
              color="primary"
              text="{{ dataItem.name }}"
            >
            </hyperkit-link>
          }
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="environments"
        title="Environments"
        [width]="200"
      >
        <ng-template kendoGridFilterCellTemplate let-filter>
          <multiselect-environment-filter
            #template_env_multiselect
            [filter]="
              (huntTemplateStateService.huntTemplateState | async).filter
            "
            field="environments"
            [data]="environments"
            textField="name"
            valueField="id"
          ></multiselect-environment-filter>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          @if (dataItem.environments) {
            @for (env of dataItem.environments; track env; let isLast = $last) {
              <hyperkit-link
                display="inline"
                routerLink="/settings/environment"
                variant="emphasized"
                size="sm"
                color="primary"
                text="{{ env.name }}"
              >
              </hyperkit-link>
              @if (!isLast) {
                <span>, </span>
              }
            }
          }
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        [sortable]="false"
        filter="numeric"
        field="numHuntPacks"
        title="# Hunt Packs"
        [width]="100"
      >
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
          <kendo-grid-numeric-filter-cell
            format="#"
            [max]="25"
            [min]="0"
            [showOperators]="false"
            [column]="column"
            [filter]="
              (huntTemplateStateService.huntTemplateState | async).filter
            "
          >
          </kendo-grid-numeric-filter-cell>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          @if (dataItem.huntPackages) {
            <span>{{ dataItem.huntPackages.length }}</span>
          }
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        [sortable]="false"
        filter="numeric"
        field="numHunts"
        title="# Hunts"
        [width]="100"
      >
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
          <kendo-grid-numeric-filter-cell
            format="#"
            [max]="25"
            [min]="0"
            [showOperators]="false"
            [column]="column"
            [filter]="
              (huntTemplateStateService.huntTemplateState | async).filter
            "
          >
          </kendo-grid-numeric-filter-cell>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          @if (dataItem.huntCount) {
            <span>{{ dataItem.huntCount }}</span>
          }
        </ng-template>
      </kendo-grid-column>
      <!-- <kendo-grid-column
    field="templateName"
    title="Planned"
    [width]="110"
    >
    <ng-template kendoGridCellTemplate let-dataItem>
      <input
        type="checkbox"
        disabled
        [checked]="dataItem.planned == 'true'"
        kendoCheckBox
        />
    </ng-template>
  </kendo-grid-column> -->

      <!-- <kendo-grid-column
  field="frequency"
  title="Frequency"
  [width]="120"
  >
</kendo-grid-column> -->

      <kendo-grid-column
        field="priority"
        title="Priority"
        [width]="150"
        [class]="{ 'text-center': true }"
        [resizable]="false"
      >
        <ng-template kendoGridFilterCellTemplate let-filter>
          <multiselect-tag-filter
            #template_multiselect
            [filter]="
              (huntTemplateStateService.huntTemplateState | async).filter
            "
            field="priority"
            [data]="priorityFilters"
            textField="text"
            valueField="value"
          ></multiselect-tag-filter>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          @if (dataItem.priority) {
            <hyperkit-badge
              [variant]="dataItem.priority | priorityBadge"
              [text]="dataItem.priority"
            ></hyperkit-badge>
          }
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="created" title="Created" [width]="150">
        <ng-template kendoGridFilterCellTemplate let-filter>
          <date-range-filter
            #template_datepicker
            class="date-range-filter"
            [filter]="
              (huntTemplateStateService.huntTemplateState | async).filter
            "
            field="created"
          >
          </date-range-filter>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.created | date: 'longDate' }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="lastModified"
        title="Last Modified"
        [width]="150"
      >
        <ng-template kendoGridFilterCellTemplate let-filter>
          <date-range-filter
            #template_datepicker
            class="date-range-filter"
            [filter]="filter"
            field="lastModified"
          >
          </date-range-filter>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.lastModified | date: 'longDate' }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="author" title="Author" [width]="150">
        <ng-template kendoGridFilterCellTemplate let-filter>
          <dropdown-filter
            #template_dropdown
            [filter]="
              (huntTemplateStateService.huntTemplateState | async).filter
            "
            field="author"
            [data]="users$ | async"
            textField="fullName"
            valueField="id"
          ></dropdown-filter>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          @if (dataItem.author) {
            <span
              >{{ dataItem.author?.firstName }}
              {{ dataItem.author?.lastName }}</span
            >
          } @else {
            (deleted)
          }
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="defaultAssignee"
        title="Default Assignee"
        [width]="150"
      >
        <ng-template kendoGridFilterCellTemplate let-filter>
          <dropdown-filter
            #template_dropdown
            [filter]="
              (huntTemplateStateService.huntTemplateState | async).filter
            "
            field="defaultAssignee"
            [data]="users$ | async"
            textField="fullName"
            valueField="id"
          ></dropdown-filter>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          @if (dataItem.defaultAssignee) {
            <span
              >{{ dataItem.defaultAssignee?.firstName }}
              {{ dataItem.defaultAssignee?.lastName }}</span
            >
          } @else {
            Unassigned
          }
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        [sortable]="false"
        [filterable]="false"
        field="id"
        title=""
        [width]="150"
        class="overflow-column"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="button-options">
            <hyperkit-tooltip
              [text]="getTooltipText(dataItem)"
              position="left"
              tip="center"
            >
              @if (
                !(huntTemplateStateService.huntTemplateState | async).archived
              ) {
                <hyperkit-button
                  size="small"
                  (click)="newHunt(dataItem)"
                  [disabled]="isHuntDisabled(dataItem)"
                  variant="standard"
                  color="tertiary"
                  text="Hunt"
                ></hyperkit-button>
              }
            </hyperkit-tooltip>
            @if (
              !(huntTemplateStateService.huntTemplateState | async).archived
            ) {
              <hyperkit-button
                size="small"
                (click)="archiveTemplate(dataItem)"
                variant="standard"
                color="secondary"
                text="Archive"
              ></hyperkit-button>
            }
            @if (
              (huntTemplateStateService.huntTemplateState | async).archived
            ) {
              <hyperkit-button
                size="small"
                (click)="unarchiveTemplate(dataItem)"
                variant="standard"
                color="secondary"
                text="Unarchive"
              ></hyperkit-button>
            }
          </div>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </div>
</div>
